import {
  FolderOpenIcon,
  GraduationCapIcon,
  LibraryIcon,
  ListOrderedIcon,
  RepeatIcon,
  RouteIcon,
  TimerIcon,
  WrenchIcon,
} from 'lucide-react'

export const CHECKOUT_URL = 'https://profesor-tecnico-en-electronica.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/5akQcMwsteLM6WDndrgtBY/Imagen_de_Codex_29_sept_2026,_22_19_50.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR TÉCNICO EN ELECTRÓNICA'
export const PACK_IMAGE_ALT = 'MEGA PACK PROFESOR TÉCNICO EN ELECTRÓNICA: 6 tomos digitales y 5 bonos incluidos'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'
export const CTA_LABEL = '🚀 Sí, quiero comenzar ahora'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: FolderOpenIcon,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Tienes apuntes, PDFs, videos, circuitos y ejercicios guardados en diferentes lugares, pero cada vez que necesitas preparar una clase tienes que volver a buscar y organizar todo.',
  },
  {
    icon: ListOrderedIcon,
    title: 'NO SABES CÓMO ORDENAR LOS TEMAS',
    desc: 'Componentes, multímetro, mediciones, fuentes, circuitos, sensores, diagnóstico... hay muchos contenidos y no siempre es fácil decidir qué enseñar primero y qué debería aprender el alumno después.',
  },
  {
    icon: WrenchIcon,
    title: 'TE FALTAN PRÁCTICAS',
    desc: 'Explicar teoría es solo una parte. También necesitas ejercicios, circuitos, mediciones, actividades y proyectos que permitan llevar los conceptos al taller.',
  },
  {
    icon: RepeatIcon,
    title: 'SIGUES PREPARANDO TODO DESDE CERO',
    desc: 'Cada nueva clase significa volver a buscar información, crear ejercicios, pensar una práctica y organizar materiales que podrías tener preparados dentro de un mismo sistema.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS Y COMPONENTES ELECTRÓNICOS',
    desc: 'Trabaja conceptos fundamentales como tensión, corriente, resistencia, potencia y Ley de Ohm, junto con resistencias, capacitores, diodos, LED, transistores, MOSFET, relés, protecciones y simbología electrónica.',
  },
  {
    title: 'MULTÍMETRO Y MEDICIONES ELECTRÓNICAS',
    desc: 'Aprende a trabajar con tensión, resistencia, continuidad, corriente, diodos, LED y comprobación de componentes utilizando un método ordenado para seleccionar, medir e interpretar resultados.',
  },
  {
    title: 'FUENTES DE ALIMENTACIÓN Y ELECTRÓNICA DE POTENCIA',
    desc: 'Comprende transformadores, rectificación, filtrado, regulación, fuentes lineales y conmutadas, convertidores, protecciones, mediciones y diagnóstico básico de las diferentes etapas de alimentación.',
  },
  {
    title: 'CIRCUITOS ELECTRÓNICOS DESDE CERO',
    desc: 'Trabaja lectura de esquemas, circuitos serie y paralelo, divisores de tensión, protoboard, LED, transistores, relés, sensores, LDR, temporizadores y circuitos integrados mediante actividades progresivas.',
  },
  {
    title: 'DIAGNÓSTICO, FALLAS Y REPARACIÓN',
    desc: 'Aprende un método ordenado para observar síntomas, comprobar alimentación, realizar mediciones, localizar circuitos abiertos, cortocircuitos y componentes defectuosos hasta identificar posibles fallas.',
  },
  {
    title: 'PRÁCTICAS DE TALLER Y PROYECTOS PARA ALUMNOS',
    desc: 'Lleva la teoría a la práctica con actividades de componentes, mediciones, LED, sensores, transistores, relés, fuentes, diagnóstico y proyectos que pueden utilizarse y adaptarse para el aula o taller.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '50 PRÁCTICAS DE ELECTRÓNICA PARA AULA Y TALLER',
    desc: '50 actividades progresivas para trabajar componentes, multímetro, mediciones, circuitos, sensores, control, fuentes y diagnóstico con los alumnos.',
    value: '$7.990',
  },
  {
    title: 'GUÍA VISUAL DE COMPONENTES Y SIMBOLOGÍA ELECTRÓNICA',
    desc: 'Recurso visual para identificar resistencias, capacitores, diodos, LED, transistores, MOSFET, relés, sensores, reguladores, integrados, transformadores y sus principales símbolos.',
    value: '$5.990',
  },
  {
    title: 'EJERCICIOS, ACTIVIDADES Y EVALUACIONES PARA ALUMNOS',
    desc: 'Banco de preguntas, ejercicios, cálculos, actividades de medición, interpretación de circuitos, diagnóstico y modelos de evaluación teórica y práctica.',
    value: '$6.990',
  },
  {
    title: '25 PROYECTOS ELECTRÓNICOS PARA TALLER',
    desc: 'Proyectos progresivos con LED, sensores, transistores, relés, temporizadores, fuentes, alarmas y sistemas integradores para llevar los conocimientos a la práctica.',
    value: '$8.990',
  },
  {
    title: 'GUÍA PRÁCTICA DE FALLAS Y DIAGNÓSTICO ELECTRÓNICO',
    desc: 'Método práctico para trabajar inspección, alimentación, mediciones, circuitos abiertos, cortocircuitos, componentes defectuosos y casos de diagnóstico con fallas intencionales.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: TimerIcon,
    title: 'MENOS TIEMPO PREPARANDO',
    desc: 'Deja de buscar contenidos separados cada vez que necesitas explicar un tema y sigue una ruta organizada desde fundamentos hasta circuitos, diagnóstico y proyectos.',
  },
  {
    icon: WrenchIcon,
    title: 'MÁS MATERIAL PRÁCTICO',
    desc: 'Ten a disposición componentes, mediciones, ejercicios, prácticas, evaluaciones y proyectos para complementar la teoría con actividades de aula y taller.',
  },
  {
    icon: RouteIcon,
    title: 'CLASES CON MAYOR CONTINUIDAD',
    desc: 'Organiza los contenidos para que tus alumnos puedan avanzar desde identificar un componente hasta montar, medir, interpretar y diagnosticar un circuito.',
  },
  {
    icon: LibraryIcon,
    title: 'UN SISTEMA PARA ENSEÑAR',
    desc: 'Construye una base de material educativo que puedas consultar, adaptar y utilizar como apoyo para preparar diferentes clases de electrónica.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tenía muchos apuntes y material de electrónica, pero cada vez que preparaba una clase terminaba buscando información nuevamente. Tener los temas separados y ordenados me ayudó a organizar mucho mejor qué trabajar primero.',
    author: 'Diego Fernández',
    meta: 'Profesor técnico, 38 años · Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me sirvió fueron las prácticas. Muchas veces tenía clara la explicación teórica, pero necesitaba actividades para que los alumnos realmente midieran, armaran circuitos y entendieran lo que estaban haciendo.',
    author: 'Marcelo Ibáñez',
    meta: 'Instructor de electrónica, 43 años · Córdoba, Argentina',
  },
  {
    quote:
      'Doy materias técnicas y necesitaba ordenar mejor componentes, multímetro, circuitos y diagnóstico. Ahora tengo una secuencia que puedo consultar y adaptar según el nivel de mis alumnos.',
    author: 'Laura Quiroga',
    meta: 'Docente técnica, 35 años · Montevideo, Uruguay',
  },
  {
    quote:
      'El material de diagnóstico me gustó porque permite plantear circuitos con fallas y hacer que los alumnos busquen el problema mediante mediciones en lugar de decirles directamente qué está mal.',
    author: 'Cristian Molina',
    meta: 'Técnico e instructor, 32 años · Santiago, Chile',
  },
  {
    quote:
      'Buscaba más ideas para el taller y los proyectos me dieron una estructura para combinar teoría, montaje, mediciones y evaluación dentro de una misma actividad.',
    author: 'Héctor Ramírez',
    meta: 'Profesor de electrónica, 48 años · Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito ser profesor de electrónica?',
    a: 'No necesariamente. Está pensado para profesores, instructores, técnicos y personas que están comenzando a enseñar electrónica.',
  },
  {
    q: '¿Qué contenidos incluye?',
    a: '6 tomos: fundamentos y componentes, multímetro y mediciones, fuentes de alimentación, circuitos desde cero, diagnóstico y fallas, y prácticas de taller y proyectos, más 5 bonos.',
  },
  {
    q: '¿Incluye prácticas para alumnos?',
    a: 'Sí. Incluye 50 prácticas, 25 proyectos, ejercicios, actividades y evaluaciones para llevar la teoría al aula o taller.',
  },
  { q: '¿Los bonos tienen costo adicional?', a: 'No. Los 5 bonos están incluidos con tu compra.' },
  { q: '¿Es un pago único?', a: 'Sí. Realizas un único pago, sin mensualidades.' },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al ser contenido digital, recibirás las instrucciones de acceso después de completar tu compra.',
  },
  {
    q: '¿Reemplaza la formación docente o técnica?',
    a: 'No. Es material educativo de apoyo y no sustituye formación, práctica supervisada, normativa de seguridad ni el criterio de un profesional habilitado.',
  },
  {
    q: '¿Puedo adaptar el material a mis clases?',
    a: 'Sí. Puedes adaptarlo al nivel de tus alumnos, al curso y al equipamiento disponible en tu aula o taller.',
  },
  { q: '¿Dónde solicito soporte?', a: 'Puedes comunicarte mediante nuestro correo de soporte.' },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín G.', city: 'Buenos Aires', country: 'Argentina', minutes: 2 },
  { name: 'Laura P.', city: 'Córdoba', country: 'Argentina', minutes: 4 },
  { name: 'Diego F.', city: 'Rosario', country: 'Argentina', minutes: 6 },
  { name: 'Silvia R.', city: 'Mendoza', country: 'Argentina', minutes: 9 },
  { name: 'Gustavo M.', city: 'La Plata', country: 'Argentina', minutes: 12 },
  { name: 'Claudia V.', city: 'San Miguel de Tucumán', country: 'Argentina', minutes: 15 },
  { name: 'Ricardo A.', city: 'Mar del Plata', country: 'Argentina', minutes: 19 },
  { name: 'Patricia L.', city: 'Salta', country: 'Argentina', minutes: 23 },
  { name: 'Hernán S.', city: 'Neuquén', country: 'Argentina', minutes: 28 },
  { name: 'Mónica T.', city: 'Santa Fe', country: 'Argentina', minutes: 33 },
  { name: 'Pablo D.', city: 'Bahía Blanca', country: 'Argentina', minutes: 39 },
  { name: 'Andrea C.', city: 'Corrientes', country: 'Argentina', minutes: 45 },
]
